import { PAGE_DOMAIN, SME_CLIENT_ID, SME_URL } from "constants/api";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { clearTokens } from "utils/cookies";
import { v4 as uuid } from "uuid";
import { useAuthFlow } from './AuthFlowContext';

const useSMEIAM = (props) => {
    const state = uuid()
    const codeVerifier = uuid()

    const config = {
        authorization_endpoint: SME_URL + "/auth/realms/sme-portal/protocol/openid-connect/auth"
    }
    const { updateSSOFlow } = useAuthFlow()

    const [url, setURL] = useState('')
    const [urlReady, setURLReady] = useState(false)
    const [loginState, setLoginState] = useState(false)
    const [params] = useSearchParams();
    const isProvideService = params.get('isProvideService');

    const login = () => {
        clearTokens()
        setLoginState(true)
        localStorage.setItem("checkEventPopupByUser", 1);
    }

    useEffect(() => {
        const generatedUrl = config.authorization_endpoint + "?response_type=code&client_id=" + SME_CLIENT_ID + "&redirect_uri=" + PAGE_DOMAIN + "iam/callback/sme"
        setURL(generatedUrl)
        setURLReady(true)
        localStorage.setItem("checkEventPopupByUser", 1);
        if (props?.autoLogin) {
            window.location = generatedUrl
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (urlReady && loginState) {
            updateSSOFlow({
                info: {
                    isProvideService: isProvideService === 'true',
                    code_verifier: codeVerifier,
                    redirect_uri: PAGE_DOMAIN + "iam/callback/sme",
                },
            })
            setTimeout(() => {
                window.location = url
            }, 300)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [urlReady, loginState])

    return {
        url,
        urlReady,
        state,
        login
    }

}

export default useSMEIAM
